export default "__VITE_ASSET__CVbVIxhl__"